import { render, staticRenderFns } from "./Faucet.vue?vue&type=template&id=2ca5673c&scoped=true&"
import script from "./Faucet.vue?vue&type=script&lang=js&"
export * from "./Faucet.vue?vue&type=script&lang=js&"
import style0 from "./Faucet.vue?vue&type=style&index=0&id=2ca5673c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca5673c",
  null
  
)

export default component.exports